<!--
 * @Author: gongzhichao
 * @Date: 2023-04-17 00:00:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 详情页面-文章
-->
<template>
  <div class="main">
    <SecondPage>
      <div class="detail-content">
        <div class="header">
          <div class="title">{{ detailObj.postTitle }}</div>
          <div class="createdTime">
            {{
              detailObj.virtualTime
                ? detailObj.virtualTime
                : detailObj.createTime
            }}
          </div>
        </div>
        <div
          class="details-pane"
          v-html="$utils.decodeHtml(detailObj.postContent)"
        ></div>
      </div>
    </SecondPage>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SecondPage from "../component/SecondPage/SecondPage.vue";
import webSiteHigh from "../../../api/webSiteHigh";
import webSite from "../../../api/webSite";
import webSiteThree from "../../../api/webSiteThree";
export default {
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  components: { SecondPage },

  watch: {
    "$route.query": {
      async handler(newVal, oldVal) {
        if (newVal.type == "footer") {
          let {
            otContent: postContent,
            otTitle: postTitle,
            createTime,
            virtualTime,
          } = await this.searchFooter({ ftType: newVal.id });
          this.detailObj = { postTitle, postContent, createTime, virtualTime };
        }
      },
    },
    deep: true,
  },
  data() {
    return {
      detailObj: {
        postTitle: "",
        createTime: "",
        postContent: "",
      },
    };
  },
  // 组件路由守卫
  beforeRouteEnter(to, from, next) {
    document.title = "群侠传";
    let { title } = to.query;
    if (to.meta.title) document.title = title;
    next();
  },
 mounted() {
     this.initDetail()
  },
  methods: {
    ...mapActions({
      searchOthers: "base/searchOthers",
      searchFooter: "base/searchFooter",
      searchNewsById: "base/searchNewsById",
    }),
       
    async initDetail() {
      let { id, title, type } = this.$route.query;
      const storedValue = sessionStorage.getItem('toggleTab');
      if(storedValue === 'threeExplosive'){
        if (title == "版本介绍") {
        let res = await webSiteThree.searchOthers({ otType: id });
        let {
          otContent: postContent,
          otTitle: postTitle,
          createTime,
          virtualTime// 如果 virtualTime 可能不存在，设置默认值
       } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };
       } else if (type == "footer") {

        let res = await webSiteThree.searchFooter({ ftType: id });
        let {
          otContent: postContent,
          otTitle: postTitle,
          createTime,
          virtualTime// 如果 virtualTime 可能不存在，设置默认值
       } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };
      } else {

        let res = await webSiteThree.searchNewsById({ id });
        let {
        title: postTitle,
        content: postContent,
        createTime,
        virtualTime = '' // 如果 virtualTime 可能不存在，设置默认值
        } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };

        }

      }else if(storedValue === 'highExplosive'){
        if (title == "版本介绍") {
        let res = await webSiteHigh.searchOthers({ otType: id });
        let {
          otContent: postContent,
          otTitle: postTitle,
          createTime,
          virtualTime// 如果 virtualTime 可能不存在，设置默认值
       } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };
       } else if (type == "footer") {

        let res = await webSiteHigh.searchFooter({ ftType: id });
        let {
          otContent: postContent,
          otTitle: postTitle,
          createTime,
          virtualTime// 如果 virtualTime 可能不存在，设置默认值
       } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };
      } else {

        let res = await webSiteHigh.searchNewsById({ id });
        let {
        title: postTitle,
        content: postContent,
        createTime,
        virtualTime = '' // 如果 virtualTime 可能不存在，设置默认值
        } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };

        }

      }else{

      if (title == "版本介绍") {
        let res = await webSite.searchOthers({ otType: id });
        let {
          otContent: postContent,
          otTitle: postTitle,
          createTime,
          virtualTime// 如果 virtualTime 可能不存在，设置默认值
      } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };
      } else if (type == "footer") {

        let res = await webSite.searchFooter({ ftType: id });
        let {
          otContent: postContent,
          otTitle: postTitle,
          createTime,
          virtualTime// 如果 virtualTime 可能不存在，设置默认值
      } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };
      } else {

        let res = await webSite.searchNewsById({ id });
        let {
        title: postTitle,
        content: postContent,
        createTime,
        virtualTime = '' // 如果 virtualTime 可能不存在，设置默认值
      } = res.data; // 假设数据在 res.data 里，根据实际接口结构调整
        this.detailObj = { postTitle, postContent, createTime, virtualTime };

      }
    }


    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  .detail-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      width: 100%;
      height: auto;
      padding: 10px 0;
      border-bottom: 1px solid #cdba9f;
      color: #8c5d26;
      .title {
        width: 350px;
        font-size: 20px;
        font-weight: 500;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
      .createdTime {
        font-size: 16px;
        margin-top: 12px;
      }
    }
    .details-pane {
      max-width: 100%;
      padding: 20px 0;
      white-space: pre-line;
      /deep/ table {
        width: 100% !important;
      }
      /deep/ .text-only {
        min-width: 100%;
        white-space: pre-line !important;
      }

      /deep/ img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>
